import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Translate from './Translate';
import { Theme } from '../models/Theme';

const Value = styled<any, any>('div', 'value', 'changeIndicatorValue')`
    ${propStyles};
`;

Value.defaultProps = {
    textDecoration: 'inherit',
};

interface ChangeIndicatorValueProps {
    changeTheme: string | number;
    color: string;
    theme?: Theme;
    value: string | number;
}

const iconStyleProps = {
    display: 'inline-block',
    verticalAlign: 'middle',
};

@observer
class ChangeIndicatorValue extends Component<ChangeIndicatorValueProps> {
    render() {
        const { changeTheme, color, theme, value } = this.props;
        return (
            <Value
                color={color}
                {...changeTheme}
                {...theme.ChangeValue}
                {...iconStyleProps}
            >
                <Translate>{value}</Translate>
            </Value>
        );
    }
}

export default withTheme(ChangeIndicatorValue);



// WEBPACK FOOTER //
// ./src/Components/ChangeIndicatorValue.tsx